import React, { useState } from 'react';
import SAEChart from './components/Charts/SAEChart';
import SAEForm from './components/Widgets/SAEForm';
import { Col, Row } from 'react-bootstrap';

export function SAESearch() {

    const [formData, setFormData] = useState({});

    const handleFormChange = (newData) => {
        setFormData(newData);
    };

    return (
        <Row>
            <Col lg={3} className="p-5 institute-filter">
                <SAEForm formData={formData} onFormChange={handleFormChange} />
                <Col xs={12} sm={12}>
                    <p className='mt-4'><strong>Note:</strong> Some Institutional Classifications include colleges with a mix of award levels. In those cases (Special Focus: Business, Special Focus: Nursing, and Special Focus: Other Health Professions, and Special Focus: Arts, Music, and Design), the threshold for the higher earnings category for all institutions in that classification is set at 1.25 (25% higher than the comparison earnings) regardless of the award level focus at a particular institution. In this visual, those institutions will display on the Primarily Associate filter.</p>
                </Col>
            </Col>
            <Col lg={9} className="p-5">
                <SAEChart formData={formData} legend={false} />
            </Col>
            <Row>
            </Row>

        </Row>

    );
}

